/**
 * Imedia - Privacy
 */

(() => {
  'use strict';

  const cc_name = 'pantoute_cc';
  const cc_en_description = `We use cookies and similar technologies to improve your browsing experience, monitor the traffic and performance of our site.`;
  const cc_fr_description = `Nous utilisons des témoins et des technologies similaires pour améliorer votre expérience de navigation, contrôler le trafic et les performances de notre site.`;

  window.onload = function () {
    const consent = initCookieConsent();

    /**
     * Cookie Consent
     */
    const consentConfig = {
      current_lang: theme_js_vars?.language ?? 'fr',
      autoclear_cookies: true,
      page_scripts: true,
      hide_from_bots: true,
      cookie_name: `${cc_name}_preferences`,
      cookie_expiration: 30,
      onAccept: function () {},
      onChange: function () {},
      languages: {
        en: {
          consent_modal: {
            title: 'We use cookies',
            description: `${cc_en_description} ${
              theme_js_vars?.privacy_policy
                ? `For more details relative to cookies and how we treat your personal data, please read the full ${theme_js_vars.privacy_policy}.`
                : ''
            }`,
            primary_btn: {
              text: 'Accept all',
              role: 'accept_all',
            },
            secondary_btn: {
              text: 'Customize',
              role: 'settings',
            },
          },
          settings_modal: {
            title: 'Cookie preferences',
            save_settings_btn: 'Save settings',
            accept_all_btn: 'Accept all',
            reject_all_btn: 'Reject all',
            close_btn_label: 'Close',
            blocks: [
              {
                title: 'Cookie usage',
                description:
                  'You can customize your cookie preferences by changing your browser settings or personalizing your choices below.',
              },
              {
                title: 'Essential cookies (mandatory)',
                description:
                  'These cookies enhance your browsing experience and are essential for the smooth operation of various features.',
                toggle: {
                  value: 'necessary',
                  enabled: true,
                  readonly: true,
                },
              },
              {
                title: 'Analysis and advertising cookies',
                description:
                  'These cookies are used to analyze browsing behavior, improve the performance of our platform and identify your advertising choices.',
                toggle: {
                  value: 'analytics',
                  enabled: false,
                  readonly: false,
                },
              },
            ],
          },
        },
        fr: {
          consent_modal: {
            title: 'Nous utilisons des témoins',
            description: `${cc_fr_description} ${
              theme_js_vars?.privacy_policy
                ? `Pour en savoir plus sur l'utilisation des témoins et sur la manière dont nous traitons vos données personnelles, consultez notre page ${theme_js_vars.privacy_policy}.`
                : ''
            }`,
            primary_btn: {
              text: 'Accepter tout',
              role: 'accept_all',
            },
            secondary_btn: {
              text: 'Personnaliser',
              role: 'settings',
            },
          },
          settings_modal: {
            title: 'Préférences témoins',
            save_settings_btn: 'Enregistrer',
            accept_all_btn: 'Accepter tout',
            reject_all_btn: 'Refuser tout',
            close_btn_label: 'Fermer',
            blocks: [
              {
                title: 'Utilisation des témoins',
                description:
                  'Vous pouvez adapter vos préférences en matière de témoins en modifiant les paramètres de votre navigateur ou en personnalisant vos choix ci-dessous.',
              },
              {
                title: 'Témoins essentiels (obligatoires)',
                description:
                  "Ces témoins permettent d'optimiser votre expérience de navigation et sont essentiels au bon fonctionnement de notre plateforme.",
                toggle: {
                  value: 'necessary',
                  enabled: true,
                  readonly: true,
                },
              },
              {
                title: "Témoins d'analyse et publicitaires",
                description:
                  "Ces témoins permettent d'analyser les comportements de navigation, d'améliorer les performances de notre plateforme et identifier vos choix en matière de publicité.",
                toggle: {
                  value: 'analytics',
                  enabled: false,
                  readonly: false,
                },
              },
            ],
          },
        },
      },
    };

    consent.run(consentConfig);
  };
})();
